<template>
  <div
    style="z-index:9; position: fixed; bottom: 0px; right: 0px;
        background-color: white; width: 95%;
        border-top: 1px solid #E6E6E6; height:70px;
        text-align: center;display: flex; align-items: center; justify-content: center;"
    class="Jost"
  >
    <div v-if="currentStep === 1" style="display: flex; align-items: center; justify-content:space-between;width: 90%;">
      <div style="display: flex; align-items: center;justify-content:space-around ;width:300px; ">
        <div style="color:#F25555;border:solid 2px #F25555;border-radius: 10px; font-weight:500;padding:8px">未付款</div>
        <div style="text-align: left;line-height:normal">
          <div style="font-size:18px;color:#000000;font-weight: 500;">應付 NT ${{ formatNumber(totalPrice) || '0' }}</div>
          <div>快速查詢客戶</div>
        </div>
      </div>
    </div>

    <div v-if="currentStep === 2" style="display: flex; align-items: center; justify-content: space-between; width:90%">
      <div style="display: flex; align-items: center;justify-content:space-between ;width:300px; ">
        <div style="color:#F25555;border:solid 2px #F25555;border-radius: 10px; font-weight:500;padding:8px">未付款</div>
        <div style="text-align: left;line-height:normal">
          <div style="font-size:18px;color:#000000;font-weight: 500;">應付 NT ${{ formatNumber(totalPrice) || '0' }}</div>
          <div>可入住數： 1 ~ {{ currentMaxAccommodates }} 隻、可多選</div>
        </div>
      </div>
      <el-button type="primary" round style="width: 40%;" :disabled="!(selectedPets.length > 0)" @click="$emit('next-step', 3)">下一步</el-button>
    </div>

    <div v-if="currentStep === 3" style="display: flex; align-items: center; justify-content: space-between; width:90%">
      <div style="display: flex; align-items: center;justify-content:space-between ;width:300px; ">
        <div style="color:#F25555;border:solid 2px #F25555;border-radius: 10px; font-weight:500;padding:8px">未付款</div>
        <div style="text-align: left;line-height:normal">
          <div style="font-size:18px;color:#000000;font-weight: 500;">應付 NT ${{ formatNumber(totalPrice) || '0' }}</div>
          <div>確認資訊後，即可進行下一步</div>
        </div>
      </div>
      <div style="display: flex; align-items: center;justify-content:flex-end ;width: calc(100% - 350px);">
        <el-button round style="width:32%" @click="$emit('cancel-order')">取消建立訂單</el-button>
        <el-button type="primary" round style="width:32%" @click="$emit('build-booking-order', false)">訂單建立</el-button>
        <!-- <el-button type="primary" round style="width:32%">預約下一筆</el-button> -->
      </div>
    </div>
    <div v-if="currentStep === 'viewOrder'" style="display: flex; align-items: center; justify-content: space-between; width:90%">
      <div style="display: flex; align-items: center;justify-content:space-between ;width:220px; ">
        <div
          :style="{
            color: paymentStatusMeta.color,
            border: `solid 2px ${paymentStatusMeta.color}`,
            borderRadius: '10px',
            fontWeight: '500',
            padding: '8px',
            textAlign: 'center',
            width: 'fit-content',
          }"
        >
          {{ paymentStatusMeta.label }}
        </div>
        <div style="text-align: left;line-height:normal">
          <div style="font-size:18px;color:#000000;font-weight: 500;"> NT ${{ formatNumber(totalPrice) }}</div>
          <div>{{ getPaymentMethodName(orderPaymentStatus.paymentMethod) }}</div>
        </div>
      </div>
      <div style="display: flex; align-items: center;justify-content:right ;width: calc(100% - 350px);gap:14px">
        <el-button icon="el-icon-message" @click="$emit('open-notification-dialog')" style="font-size:20px" circle />
        <el-button icon="el-icon-s-promotion" @click="$emit('open-share-link-dialog')" style="font-size:20px" circle />
        <template v-if="orderPaymentStatus.paymentStatus === 'UNPAID'">
          <el-button type="primary" round style="width:32%" @click="$emit('go-to-payment')">前往付款</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAYMENT_METHOD_MAP } from '@/src/router/views/payment/constant/paymentStatusMap'

const PAYMENT_STATUS_META = {
  UNPAID: { label: '未付款', color: '#F25555' },
  PAID: { label: '已付款', color: '#67C23A' },
}

export default {
  name: 'hotelOrderBottomBar',
  components: {},
  props: {
    currentStep: {
      type: [Number, String],
      default: 0,
    },
    totalPrice: {
      type: Number,
      default: 0,
    },
    orderPaymentStatus: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      paymentMethodMap: PAYMENT_METHOD_MAP,
    }
  },
  computed: {
    ...mapGetters('hotel/order', ['currentMaxAccommodates', 'selectedPets']),
    paymentStatusMeta() {
      const status = this.orderPaymentStatus.paymentStatus
      return PAYMENT_STATUS_META[status] || { label: '-', color: '#909399' }
    },
  },
  methods: {
    formatNumber(num) {
      return num.toLocaleString()
    },
    getPaymentMethodName(method) {
      return this.paymentMethodMap[method] || method // 如果找不到對應，顯示原始值
    },
  },
}
</script>

<style lang="scss" scoped></style>
